import {Component, EventEmitter, OnChanges, OnInit, Output, AfterViewInit, Input} from '@angular/core';
import {trigger, style, animate, transition,keyframes} from '@angular/animations';
import {CommonService} from "../common.service";
import {ApiService} from "../api.service";

declare var jquery:any;
declare var $ :any;
declare var polyvPlayer :any;

@Component({
  selector: 'app-case-practice-cooperation-video',
  templateUrl: './case-practice-cooperation-video.component.html',
  styleUrls: ['./case-practice-cooperation-video.component.css'],
  animations: [
   trigger(
     'videoAnimation', [
       transition(':enter', [
         style({opacity: 0}),
         animate('1s ease-out', style({opacity: 1}))
       ]),
       transition(':leave', animate('500ms', keyframes([
          style({opacity: 1, transform: 'scale(1, 1)'}),
          style({opacity: 0, transform: 'scale(0, 0)'})
        ]))),
   ])
  ]
})
export class CasePracticeCooperationVideoComponent implements OnInit , AfterViewInit{
    @Input() exerciseId:number;
    @Input() isPC:boolean;
    @Output() onGoToNextStep = new EventEmitter<any>();
		showVideo:Boolean = true;
  constructor(
      private apiService: ApiService,
      private commonService:CommonService,
  ) { }

  ngOnInit() {
      let _this = this;
      window['s2j_onPlayOver'] = function () {
      	_this.showVideo = false;
				  setTimeout(function(){
				  	_this.onGoToNextStep.emit(2);
	          _this.apiService.ajax({
	              'type':'post',
	              'url':'/api/pnoStorePoint/'+_this.exerciseId,
	              'data':{
	                  'pno_store_point_id':5
	              }
	          }).subscribe(result=>{});
				  },300);
      };

  }

    ngAfterViewInit(){

        var player = polyvPlayer({
            wrap: '#video-cooperation',
            width: '100%',
            height: this.isPC ? '100vh' : window.screen.width/9*16,
            vid: '352e2664d82e30487b51c6202752d97b_3',
            // autoplay: true,
            // skinLocation: 0,
            ban_history_time: 'on',
            // hideSwitchPlayer: true,
            hideRepeat: true,
            // forceH5: true,
            flashvars: {'autoplay': true}
            // audioMode: false

        });

        if(!this.isPC){
          player.toggleFullscreen();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-video/case-practice-cooperation-video.component.ts